import { PaymentMethodTypes } from '../../../../models/domain/invoice';
import { LifeCycleStagetypes, MemberStatusTypes } from '../../../../models/domain/member';
import { MemberManager } from '../../../../managers/member.manager';
import { Component, OnInit, Input } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { UserRolesService } from '@services/user.roles.service';

@Component({
  selector: 'member-details',
  templateUrl: './member.details.component.html',
  styleUrls: ['./member.details.component.css']
})
export class MemberDetailsComponent implements OnInit {

  @Input('MemberManager') memberManager: MemberManager;

  IsBusy: boolean = false;

  status: SelectItem[];
  lifeCycleStage: SelectItem[];
  payMethod: SelectItem[];
  backendServer: SelectItem[];

  personTypes: SelectItem[];
  selectedPersonType: number;

	get NoAutoEmailBool() {
		return this.memberManager.Member().PreventAutomaticEmails == 1
	}
	
	set NoAutoEmailBool(newValue:boolean) {
		this.memberManager.Member().PreventAutomaticEmails = newValue ? 1 : 0
	}

  get ExemptFromTaxBool() {
		return this.memberManager.Member().ExemptFromTax == true
	}
	
	set ExemptFromTaxBool(newValue:boolean) {
		this.memberManager.Member().ExemptFromTax = newValue
	}

  constructor(public roles: UserRolesService) {
  }

  ngOnInit() {
    this.Init();
  }

  Init() {
    this.InitLifeCycleStage();
    this.InitPayMethod();
    this.InitMemberStatus();
    this.InitPersonTypes();
    //init the phone number formatting
    this.onPhoneInputChange(this.memberManager.Member().Phone1);
    this.onPhone2InputChange(this.memberManager.Member().Phone2);
  }

  onPhoneInputChange(value: string): void {
    const correctedValue = this.getPhoneInputValue(value);
  
    if (value !== correctedValue) {
      this.memberManager.Member().Phone1 = correctedValue;
    }
  }

  onPhone2InputChange(value: string): void {
    const correctedValue = this.getPhoneInputValue(value);
  
    if (value !== correctedValue) {
      this.memberManager.Member().Phone2 = correctedValue;
    }
  }

  public getPhoneInputValue( v : string ) : string {
	

    // trim '-' dashes
    v = v.replace(/-/g,'');
  
    v = v.replace(/[^\d]/g, "");
    
    // trim string to 15 characters
    if( v.length > 10) {
      if (v.length > 15) {
        v = v.substr(0, 15);
      }
      return '   +' + v;
    }
    
  
    // new array to hold sections of the cd key
    let numbers = [];
  
    // create set of characters from first 5 characters
    numbers.push(v.substr(0,3));
    
    // try for next 5
    if(v.substr(3,3)!=="")
      numbers.push(v.substr(3,3));
    
    // and last set of 5
    if(v.substr(6,10)!="")
      numbers.push(v.substr(6,4));
    
    if(v.substr(10,15)!="")
      numbers.push(v.substr(10,5));
  
    // add '-' dashes back to formated string
    let newValue = numbers[0];
    
    //if( newValue.length == 3 ) {
      
    //}
  
    if( numbers.length > 1 ) {
      newValue = '(' + newValue + ') ';
      newValue += numbers[1];
    }
      
  
    if (numbers.length > 2 )
      newValue += '-' + numbers[2];
  
    // if (numbers.length > 3 )
    // 	newValue += '-' + numbers[3];
  
    return newValue;
  }  


  private InitLifeCycleStage() {
    this.lifeCycleStage = [];
    this.lifeCycleStage.push({ label: 'Customer', value: LifeCycleStagetypes.Customer });
    this.lifeCycleStage.push({ label: 'Evangelist', value: LifeCycleStagetypes.Evangelist });
    this.lifeCycleStage.push({ label: 'Lead', value: LifeCycleStagetypes.Lead });
    this.lifeCycleStage.push({ label: 'Marketing Qualified Lead', value: LifeCycleStagetypes.MarketingQualifiedLead });
    this.lifeCycleStage.push({ label: 'Opportunity', value: LifeCycleStagetypes.Opportunity });
    this.lifeCycleStage.push({ label: 'Sales Qualified Lead', value: LifeCycleStagetypes.SalesQualifiedLead });
    this.lifeCycleStage.push({ label: 'Subscriber', value: LifeCycleStagetypes.Subscriber });
    this.lifeCycleStage.push({ label: 'Other', value: LifeCycleStagetypes.Other });
  }

  private InitMemberStatus() {
    this.status = [];
    this.status.push({ label: 'Active', value: MemberStatusTypes.Active });
    this.status.push({ label: 'Inactive', value: MemberStatusTypes.Inactive });
    this.status.push({ label: 'Closed', value: MemberStatusTypes.Closed });
  }

  private InitPayMethod() {
    this.payMethod = [];
    this.payMethod.push({ label: 'Credit Card', value: PaymentMethodTypes.CreditCard });
    this.payMethod.push({ label: 'Cash or Check', value: PaymentMethodTypes.CashOrCheck });
    this.payMethod.push({ label: 'Wire Transfer', value: PaymentMethodTypes.BankTransfer });
  }

  InitPersonTypes() {
    this.personTypes = [];
    // this.api.per
    this.personTypes.push({ label: 'Active Member', value : 100 });
    this.personTypes.push({ label: 'Cancelled Member', value : 110 });
    this.personTypes.push({ label: 'Active Designer', value : 200 });
    this.personTypes.push({ label: 'Cancelled Designer', value : 210 });
    this.personTypes.push({ label: 'Orphaned Designer', value : 220 });

  }

}